import { FC, useState } from "react";
import useI18n from "../../../../../hooks/useTranslations";
import Button from "../../../../ui/Button";
import ModalDialog from "../../../../ui/ModalDialog";
import UpperExtensionForm from "./UpperExtensionForm";

interface CreateUpperExtensionModalDialogButtonProps {
  installationTypeId?: string;
  steelVersionId?: string;
  upperExtensionId?: string;
}

const CreateUpperExtensionModalDialogButton: FC<CreateUpperExtensionModalDialogButtonProps> = ({
  installationTypeId,
  steelVersionId,
}) => {
  const i18n = useI18n();
  const [showNewItemDialog, setShowNewItemDialog] = useState(false);

  return (
    <>
      <Button buttonProps={{ onClick: () => setShowNewItemDialog(true) }}>{i18n.translation.common.createNew}</Button>
      {showNewItemDialog && (
        <ModalDialog onClose={() => setShowNewItemDialog(false)} title={i18n.translation.upperExtensions.createNew}>
          <UpperExtensionForm
            onCancel={() => setShowNewItemDialog(false)}
            onSave={() => {
              setShowNewItemDialog(false);
            }}
            installationTypeId={installationTypeId}
            steelVersionId={steelVersionId}
          />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateUpperExtensionModalDialogButton;
